import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useUserStore } from "../store/userStore";
import { fetchAuthToken } from "../services/api/auth";

export function useAuthSync() {
    const auth = useAuth();
    const setUser = useUserStore((s) => s.setUser);
    const setTokens = useUserStore((s) => s.setTokens);

    useEffect(() => {
        if (!auth.isAuthenticated || !auth.user) return;

        const idToken = auth.user.id_token;

        const sync  = async () => { 
            if (idToken) {
                const data = await fetchAuthToken(idToken);
                const userFromBackend = data.user_info;
                const groups = (auth.user?.profile["cognito:groups"] as string[] | undefined) ?? [];
                setUser({
                    user_id: userFromBackend.user_id,
                    username: userFromBackend.username,
                    name: userFromBackend.name,
                    profile: userFromBackend.profile,
                    cognito_username: userFromBackend.cognito_username,
                    email: userFromBackend.email,
                    groups,
                });

                setTokens({
                    cognitoIdToken: idToken,
                    backendToken: data.access_token,
                });
            }
            return;
        };
        sync();

    }, [auth.isAuthenticated, auth.user, setUser, setTokens]);
}
